import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WgIconModule } from '@watchguard/wg-ng-core';


@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  exports: [
    CommonModule,
    WgIconModule
  ]
})
export class SharedModule { }
